var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "12 8 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#002E19"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 45.3333C60 46.2763 59.6254 47.1807 58.9586 47.8475C58.2918 48.5143 57.3874 48.8889 56.4444 48.8889H35.1111L28 56V27.5556C28 26.6126 28.3746 25.7082 29.0414 25.0414C29.7082 24.3746 30.6126 24 31.5556 24H56.4444C57.3874 24 58.2918 24.3746 58.9586 25.0414C59.6254 25.7082 60 26.6126 60 27.5556V45.3333Z",
    fill: "#FFFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31.805C40.329 30.8698 40.9784 30.0811 41.8331 29.5788C42.6879 29.0765 43.6928 28.8928 44.67 29.0604C45.6472 29.228 46.5335 29.7361 47.172 30.4945C47.8104 31.253 48.1599 32.213 48.1584 33.2044C48.1584 36.0032 43.9603 37.4026 43.9603 37.4026",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0732 43H44.0832",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.387847e53086b2a70dd260ffa35da024.svg";
export { ForwardRef as ReactComponent };